
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 5h-15A1.5 1.5 0 003 6.5v9A1.5 1.5 0 004.5 17H6v4h1.244l4-4H19.5a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0019.5 5z","fill":"currentColor"}})])
          )
        }
      }
    